/* build 1785420918 */
/* ============================================================
   Floating "cart" sticky bar — Clarity Labs
   Loaded ONLY on home + collection (gated in the snippet).

   Persistent: visible whenever the cart has items. Adding to cart
   does NOT open the drawer here — it just updates this bar. "View
   Cart" opens the drawer. Hides only when the cart is empty.

   Updates are driven PRIMARILY by watching the cart drawer, which
   re-renders on every cart change (add / remove / qty) even when
   closed. That's reliable even if another app re-wraps window.fetch
   or the theme's pub/sub globals aren't present. Fetch + pub/sub are
   kept as secondary signals.
   ============================================================ */
(function () {
  "use strict";

  window.__wtStickyActive = true;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"; }
  function money(cents) {
    var v = (cents || 0) / 100;
    return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function init() {
    var bar = document.getElementById("wt-sticky-cart");
    if (!bar) return;
    var elTotal = bar.querySelector("[data-sticky-total]");
    var elCount = bar.querySelector("[data-sticky-count]");
    var hideTimer;

    // Temporary "Product Added To Cart!" toast (sits just above the bar)
    var toast = document.getElementById("wt-add-toast");
    var toastHideTimer, toastGoneTimer, lastToastAt = 0;
    function showToast() {
      if (!toast) return;
      var now = Date.now();
      if (now - lastToastAt < 1200) return; // de-dupe
      lastToastAt = now;
      clearTimeout(toastHideTimer);
      clearTimeout(toastGoneTimer);
      var h = bar && !bar.hidden ? bar.getBoundingClientRect().height : 60;
      toast.style.bottom = Math.round(h + 20) + "px";
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add("is-visible"); });
      toastHideTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        toastGoneTimer = setTimeout(function () { toast.hidden = true; }, 360);
      }, 2500);
    }

    var lastCount = null;
    function render(cart) {
      var count = cart ? cart.item_count : 0;
      // toast only when the count actually goes UP (a real add), never on remove
      if (lastCount !== null && count > lastCount) showToast();
      lastCount = count;

      if (!cart || count === 0) {
        bar.classList.remove("is-visible");
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { bar.hidden = true; }, 340);
        return;
      }
      if (elTotal) elTotal.textContent = money(cart.total_price);
      if (elCount) elCount.textContent = count + (count === 1 ? " item" : " items");
      clearTimeout(hideTimer);
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add("is-visible"); });
    }
    var lastSig = null;
    function update() {
      fetch(root() + "cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sig = (cart.item_count || 0) + ":" + (cart.total_price || 0);
          if (sig === lastSig) return; // no change — skip DOM work
          lastSig = sig;
          render(cart);
        })
        .catch(function () {});
    }

    var viewBtn = bar.querySelector(".js-sticky-viewcart");
    if (viewBtn) viewBtn.addEventListener("click", function () {
      var trigger = document.querySelector(".wt-cart__trigger");
      if (trigger) trigger.click();
    });

    // Stop the theme's product-form from auto-opening the drawer on add.
    // Skipped on product pages so the drawer can still open after add-to-cart:
    // there the snippet renders the bar with an inline style="display:none".
    var pdpBar = bar.style.display === "none";
    var drawer = document.querySelector("cart-drawer");
    if (!pdpBar && drawer && typeof drawer.renderContents === "function" && !drawer.__wtNoAutoOpen) {
      drawer.__wtNoAutoOpen = true;
      var _rc = drawer.renderContents.bind(drawer);
      drawer.renderContents = function (state) { return _rc(state, false); };
    }

    // PRIMARY: the cart drawer re-renders on every cart change (add/remove/qty),
    // even when closed. Watch it and refresh the bar. Reliable regardless of
    // fetch wrappers or missing pub/sub globals.
    var cd = document.getElementById("CartDrawer");
    if (cd) {
      var moTimer;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(update, 120);
      }).observe(cd, { childList: true, subtree: true });
    }

    // SECONDARY: intercept cart mutations via fetch (covers pages without the drawer)
    var origFetch = window.fetch;
    window.fetch = function () {
      var a0 = arguments[0];
      var url = (a0 && a0.url) || a0 || "";
      var isCart = typeof url === "string" && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var p = origFetch.apply(this, arguments);
      if (isCart) { p.then(function () { setTimeout(update, 150); }).catch(function () {}); }
      return p;
    };

    // TERTIARY: the theme's own cart pub/sub, if it exposes globals
    try {
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(update, 60); });
      }
    } catch (e) {}

    // UNIVERSAL: this store uses GoKwik's KwikCart side-cart, whose deletes /
    // qty-changes happen inside GoKwik and never touch the theme drawer or
    // (reliably) window.fetch. Poll the real Shopify cart so the bar stays in
    // sync no matter which cart UI changed it. It's a tiny JSON request, runs
    // only while the tab is visible, and skips DOM work when nothing changed.
    setInterval(function () { if (document.visibilityState !== "hidden") update(); }, 2000);
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") update(); });
    window.addEventListener("focus", update);
    window.addEventListener("pageshow", update);

    update(); // reflect current cart on load
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
